export default "__VITE_ASSET__BWzA7hL6__"